import * as React from 'react';
import { Flex } from './Flex';
import styles from './YoutubeVideo.styl';

export const YoutubeVideo = ({ id }: { id: string }) => (
    <Flex className={styles.background}>
        <iframe
            src={`https://www.youtube.com/embed/${id}`}
            allow='autoplay, fullscreen'
            className={styles.frame}
            allowFullScreen
        />
    </Flex>
);
